<template>
  <div class="column-filters">
    <div class="title">{{title}}</div>
    <div class="search-wrapper">
      <input-text
        name="search-header"
        placeholder="Search"
        :value="search"
        :onChange="onSearchChange"
      />
    </div>
    <input-select
      ref="select"
      :name="'filter_' + Math.random()"
      :options="filterOptions"
      :onChange="setValue"
      :searchable="false"
      :placeholder="placeholder"
      :multiple="false"
      :close-on-select="false"
      :selectedValue="selected"
      :loading="loading"
      :classNames="loading == true ? 'loading' : ''"
      :clearOnSelect="false"
    >
      <template slot="custom" scope="props">
        <div :class="{ 'option': true, 'selected': (selected !== null && props.scope.option.value == selected) }">
          {{ props.scope.option.label }}
        </div>
      </template>
      <template slot="noOptions">
        <span>{{$t('datatable.header_filters.empty_results')}}</span>
      </template>
    </input-select>
    <div class="actions">
      <span data-action="clear-filter" @click="clear">{{$t('datatable.header_filters.actions.clear')}}</span>
      <span data-action="apply-filter" @click="apply">{{$t('datatable.header_filters.actions.apply')}}</span>
    </div>
  </div>
</template>

<script>
import InputSelect from './form-components/input-select';
import InputText from './form-components/input-text';

export default {
  props: {
    title: {
      type: String
    },
    onFilter: {
      type: Function
    },
    onClear: {
      type: Function
    },
    placeholder: {
      type: String
    },
    onClose: {
      type: Function
    },
    applied: {
      type: Object
    },
    searchOptions: {
      type: Function
    },
    options: {
      type: Array
    }
  },

  components: {
    InputSelect,
    InputText
  },

  data: function() {
    return {
      selected: this.applied == null ? null : this.applied.value,
      search : '',
      loading: false,
      requestOptions: []
    }
  },

  computed: {
    shouldRequest: function() {
      return typeof this.searchOptions === 'function';
    },
    filterOptions: function() {
      const { search, options, requestOptions, shouldRequest } = this;
      if (shouldRequest) {
        return requestOptions;
      }
      else {
        return options.filter(opt => opt.label.toLowerCase().includes(search.toLowerCase()));
      }
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.fetch();
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    setValue: function(value) {
      this.selected = value;
    },

    apply: function() {
      const selectedOption = this.filterOptions.find(opt => opt.value == this.selected);
      this.onFilter(selectedOption);
      this.onClose();
    },

    clear: function() {
      this.setValue(null);
      this.onClear(null);
      this.onClose();
    },

    fetch: function() {
      if (this.shouldRequest) {
        this.loading = true;
        this.searchOptions(this.search).then(res => {
          this.requestOptions = res;
          this.loading = false;
        })
      }
    },

    onSearchChange: function(value) {
      this.search = value;
      if (this.search != '') {
        if (this.shouldRequest) {
          this.fetch();
        }
      }
    },

    handleScroll: function() {
      this.onClose();
    }
  }
}
</script>

<style lang="scss" scoped>
  .column-filters {
    position: fixed;
    z-index: 2;
    width: 240px;
    background-color: #FFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    transform: translateY(10px);
    // padding: 20px;
    transform: translateX(-20px);

    .title {
      padding: 20px 20px 0 20px;
    }

    .search-wrapper {
      padding: 0 20px 20px 20px;

      input {
        padding: 7px 6px;
        background-color: #f1f1f1;
        border-radius: 4px;
        font-size: 12px;

        @include placeholder;
      }
    }

    :deep(.multiselect) {
      .multiselect__select {
        display: none;
      }

      .multiselect__tags {
        padding: 0;
        min-height: 0;
        // padding: 0 20px 20px 20px;
        // cursor: default;

        .multiselect__input {
          width: 100% !important;
          position: relative !important;
          padding: 4px 6px !important;
          background-color: #f1f1f1;
          border-radius: 5px;
          font-size: 12px;

          @include placeholder;
        }

        .multiselect__single {
          display: none;
        }

        .multiselect__placeholder {
          display: none;
        }

        .multiselect__spinner {
          position: absolute;
          z-index: 51;
          // top: 50%;
          left: 50%;
          // transform: translate(-50%, -50%);
          bottom: 10px;
          // top: unset;
          transform: translateX(-50%);

          bottom: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }

      .multiselect__content-wrapper {
        display: block !important;
        position: relative;
        border-radius: 0;
        min-height: 50px;
        max-height: 200px !important;
        border: none;
        border-top: 1px solid #EEE;
        border-bottom: 1px solid #EEE;

        .multiselect__content {
          width: 100%;
        }

        .multiselect__element {
          .multiselect__option {
            padding: 0;

            .option {
              padding: 15px 20px;
              border-top: 1px solid #EEE;
              border-left: 3px solid #FFF;
              font-weight: 400;
            }

            &.multiselect__option--selected .option,
            .option.selected {
              background-color: #FFF;
              border-left-color: $vis-primary-color;
            }

            &.multiselect__option--highlight {
              background: none;
              
              .option {
                color: $vis-primary-color;
              }
            }
          }
          
          &:first-child {
            .multiselect__option {
              .option {
                border-top: none;
              }
            }
          }
        }
      }

      &:hover {
        .multiselect__tags {
          background-color: transparent;
        }
      }

      &.multiselect--active {
        .multiselect__tags {
          background-color: transparent;
        }
      }

      &.loading {
        .multiselect__content-wrapper {
          opacity: 0.5;
          pointer-events: none;

          .multiselect__content {
            display: none;
          }
        }
      }
    }

    .actions {
      padding: 10px 20px;
      font-size: 11px;
      display: flex;
      justify-content: flex-end;

      span {
        cursor: pointer;
        padding: 4px 8px;

        &:hover {
          color: $vis-primary-color;
        }
      }
    }
  }
</style>